import React from "react";
import { useParams, Navigate } from "react-router-dom";
import ClasificadorAmbulantes from "./ClasificadorAmbulantes";
import CalculoAmbulantes from "./CalculoAmbulantes";
import RegistroVendedores from "./RegistroVendedores";

const AmbulantesPage = () => {
  const { submodulo } = useParams();

  if (!submodulo) return <Navigate to="/ambulantes/registro" replace />;

  switch (submodulo) {
    case "registro": return <RegistroVendedores />;
    case "clasificador": return <ClasificadorAmbulantes />;
    case "calculo": return <CalculoAmbulantes />;
    default: return <Navigate to="/ambulantes/registro" replace />;
  }
};

export default AmbulantesPage;
